import { useState, useEffect, useRef } from 'react';

const useLiveUpdates = (enabled = true, interval = 30000) => {
  const [liveOdds, setLiveOdds] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const intervalRef = useRef(null);

  const fetchLiveOdds = async () => {
    if (!enabled) return;
    
    setIsLoading(true);
    try {
      const response = await fetch('https://3q76ugzjvgpawz6wamkcdmfavi0rqbvs.lambda-url.us-east-1.on.aws/live-odds');
      
      if (response.ok) {
        const data = await response.json();
        setLiveOdds(data);
        setLastUpdate(new Date());
      }
    } catch (error) {
      console.warn('Failed to fetch live odds:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) return;

    // Initial fetch
    fetchLiveOdds();

    // Set up interval for live updates
    intervalRef.current = setInterval(fetchLiveOdds, interval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, interval]);

  const refreshNow = () => {
    fetchLiveOdds();
  };

  return {
    liveOdds,
    lastUpdate,
    isLoading,
    refreshNow
  };
};

export default useLiveUpdates;
